var _style, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBank05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#4E2E7E;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 50
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,67.2c0,3.8,0.1,7.2-0.1,10.6c0,0.4-1,1.2-1.6,1.2c-3.6,0.1-7.2,0.1-10.7,0c-0.7,0-1.5-0.4-2.2-0.7 c-4.1-1.9-8.2-3.9-12.3-5.8c-2.4-1.1-2.5-1.6-1.9-4.2c1.6-6,3-12,4.6-18c1-4,2-8,3.1-12c0.3-0.9,0.9-1.8,1.7-2.5 c6.6-6.1,13.3-12.1,20-18.2c1-0.9,1.8-1.1,2.9,0c6.1,5.6,12.2,11.3,18.4,16.8c2.2,2,3.5,4.3,4.1,7.1c2.3,9.3,4.7,18.6,7,28 c0.2,0.6-0.5,1.9-1.1,2.2c-4.6,2.3-9.1,4.8-13.9,6.5c-2.6,0.9-5.7,0.7-8.5,0.7c-6.4,0.2-5.3,0.1-5.4-5.3c0-1.5,0-3.1,0-4.6 c-0.1-1.6,0.5-1.8,2-1.4c2.6,0.8,5.2,1.6,7.9,1.9c5.3,0.5,8-3,8.3-7.7c0.7-9.8-3-18-9.2-25.2c-2.9-3.4-6.4-6.2-9.7-9.2 c-0.9-0.9-1.9-0.8-2.9,0c-8,6-14.3,13.4-17.6,22.8c-1.5,4.2-1.7,8.8-1.1,13.2c0.4,3.8,3.3,6.3,7.1,6.1c3.1-0.2,6.2-1.1,9.3-1.7 C46.8,67.7,47.1,67.5,48,67.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBank05);
export default __webpack_public_path__ + "static/media/icon-bank-05.05513de8a625e4098bdb00199ffc5fa1.svg";
export { ForwardRef as ReactComponent };